import React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { brand } from '../theme';
import ResponsiveImage from './ResponsiveImage';

interface LogoProps {
  /** Rendered height in px (width scales with the logo's square aspect). */
  height?: number;
  sx?: SxProps<Theme>;
}

/**
 * The Werklibuebe "WB" brand mark. Uses the transparent logo asset (served as
 * WebP with a PNG fallback). Presentational only — wrap it in a link where a
 * link is wanted (e.g. the header links it to home).
 */
const Logo: React.FC<LogoProps> = ({ height = 44, sx }) => (
  <ResponsiveImage
    src={brand.logo.mark}
    alt="Werklibuebe"
    sizes={`${height}px`}
    loading="eager"
    sx={{ width: 'auto', height, ...sx }}
  />
);

export default Logo;
